module.exports = __webpack_public_path__ + "img/Shawarma Meal-Chicken.e1a6cfad.jpg";